module.exports = __webpack_public_path__ + "static/media/home-architect-image-02.0c015dd4.jpg";